import type { StatusTransition } from '../../../common/types';

export const getTransitionKeywords = (transition: StatusTransition): string => {
	if (transition.name !== transition.to.name) {
		return `${transition.name} ${transition.to.name}`;
	}
	return transition.name;
};
